import React from 'react';
import { observer, inject } from 'mobx-react';
import styled from 'styled-components';

import Backdrop from 'js/components/core/Backdrop';

import Constraint from 'js/components/Footer/Constraint';
import LovePod from "js/components-v2/pages/BuyerPage/LovePod";
import SoldOutPage from 'js/components-v2/pages/SoldOutPage/SoldOutPage';
import ShippingSelector from 'js/components/core/form/ShippingSelector';

import Container from './Container';
import DropOffDetailsContainer from './DropOffDetailsContainer';
import EstimateNoteSection from './EstimateNoteSection';
import PrimaryContainer from './PrimaryContainer';
import FeaturesContainer from './FeaturesContainer';
import KeyFeatureItem from './KeyFeatureItem';
import KeyFeaturesTitle from './KeyFeaturesTitle';
import ProductDisplay from './ProductDisplay';
import ShippingBox from './ShippingBox';
import BuyerFlowInfographic from '../BuyerFlowInfographic';
import WrapperFeaturedText from './WrapperFeaturedText';
import TextNoWrap from './TextNoWrap';
import { device } from 'js/config/style';
import Fomo from './Fomo'
import { formatCurrency } from 'js/services/Format';
import userCountry from "js/services/UserCountry";
import ShippingBoxSection from "js/components/pages/CheckoutPage/DropOffDetailsV2/ShippingBox/ShippingBoxSection";
import AddressInput from "js/components/common/AddressInput";

const KeyFeaturesDetails = styled.p`
  font-size: 12px;
`;

const keyFeaturesList = [
  {
    img: '/images/v2/buyers/security.svg',
    alt: 'Security',
    title: 'Secure payment steps',
    detail: 'When you initiate a payment using PayOnDelivery, your money gets securely held in your own account and released only when you receive and verify the item.',
  },
  {
    img: '/images/v2/buyers/card-tick.svg',
    alt: 'Transfers',
    title: 'Free transfer based on approval',
    detail: 'PayOnDelivery is built with the latest payment protection technology. It gives you a complete control over the payment. You don’t pay until you get the delivery and have verified the item.',
  },
  {
    img: '/images/v2/buyers/truck-tick.svg',
    alt: 'Delivery',
    title: 'Get delivery without leaving home',
    detail: 'We bring the goods to you within 24h! If you don’t like the product, we’ll pick it up and return for you without any hassle. Our system is integrated with FedEx and Postmates, so you can be assured that your item will be shipped safely and timely.',
  }
];



export default inject('page')(
  observer(({ page }) => {
    console.log("country: ",userCountry());
    console.log("page: ",page);
    // analytics
    if (page.sold_out) {
      return <SoldOutPage item={page.item} />
    }

    const kfiElements = keyFeaturesList.map((feature, index) => (
      <KeyFeatureItem key={index}>
        <img src={feature.img} alt={feature.alt} />
        <strong>{feature.title}</strong>
        <KeyFeaturesDetails>
          {feature.detail}
        </KeyFeaturesDetails>
      </KeyFeatureItem>
    ))
    const StyledTextNoWrap = styled(TextNoWrap)`
  @media(min-width: ${device.tablet}) {
    margin: 0 70px;
  }
`;



    const returnStep = <>
      <Backdrop>
        <Fomo item={page.item}></Fomo>
        <DropOffDetailsContainer>
          <PrimaryContainer color="#E5E9FD">
            <ProductDisplay item={page.item} />
            <ShippingBox
              address={page.address}
              addressSaved={page.addressSaved}
              page={page}
              nextStep={() => page.nextStep()}
              autoFocus={true}
            />



          </PrimaryContainer>
        </DropOffDetailsContainer>
        <DropOffDetailsContainer style={{marginTop:'7px'}}>
              <PrimaryContainer color="#E5E9FD" className="tw-w-[755px]">
                {/*{userCountry === 'NG' ? (*/}
                <Container
                  alignSelf="auto"
                  color="white"
                  display="block"
                  flexDirection="row"
                  minWidth="700px"
                  maxWidth="700px"
                  height="94px"
                  padding="10px 10px 10px 10px">
                  <div className="tw-hidden md:tw-block tw-w-[98%] md:tw-h-[94px] tw-bg-[url('/images/v2/subtract-bg.png')] tw-bg-no-repeat tw-bg-cover tw-rounded-lg">
                <span className="tw-flex tw-items-center tw-justify-between tw-w-[96%] tw-h-[100%] tw-px-5 tw-py-5 tw-align-middle">
                  <img src="/images/v2/gift-buyer.png" height="86" width="120"/>
                  <span style={{font:'inter', fontSize:'14px', lineHeight:"21px"}} className="tw-pr-4">Hey Big Baller!<br/>Welcome on board with a ₦500 signup bonus! Flex your perks now and invite 6 friends to score an additional ₦3,000. Let’s get rolling!</span>
                  <img src="/images/v2/line.png" width="2" />
                  <div className="tw-pr-[16px] tw-pl-[36px] tw-py-[12px] text-center">
                    <span className="text-xl" style={{fontWeight:'800'}}>{formatCurrency(500)}</span><br/>
                    <span>Cashback</span>
                  </div>
                </span>
                  </div>
                  <div className="md:tw-hidden tw-h-[254px] tw-w-[98%] tw-bg-[url('/images/v2/subtract-bg.png')] tw-bg-no-repeat tw-bg-cover">
                <span className="tw-flex tw-items-center tw-justify-between tw-w-[96%] tw-px-5 tw-pb-5 tw-align-middle">
                  <img src="/images/v2/gift-buyer.png" height="100" width="100"  className="tw-w-full"/>
                  <span>
                    <span className="text-xl" style={{fontWeight:'800'}}>{formatCurrency(500)}</span> &nbsp; Cashback
                  </span>
                </span>
                    <img src="/images/v2/horizontal-line.png" height="5" style={{fontWeight:'200', width:'350px', marginBottom:'1.25rem'}} />
                    <span style={{font:'inter', fontSize:'14px', lineHeight:"21px"}} className="tw-mt-[20px]">Hey Big Baller!<br/>Welcome on board with a ₦500 signup bonus! Flex your perks now and invite 6 friends to score an additional ₦3,000. Let’s get rolling!</span>
                  </div>
                </Container>
                  {/*):''}*/}
              </PrimaryContainer>
        </DropOffDetailsContainer>
        <BuyerFlowInfographic />
        <FeaturesContainer>
          <KeyFeatureItem bgColor="#F6F8FF">
            <KeyFeaturesTitle>
              Key Features
            </KeyFeaturesTitle>
            <FeaturesContainer>
              {kfiElements}
            </FeaturesContainer>
          </KeyFeatureItem>
        </FeaturesContainer>
        <div className="buyer-page">
          <LovePod />
        </div>
      </Backdrop>
    </>
    return (
      returnStep
    );
  })
);
